import api from "@/lib/api";

// Poller único y compartido de notificaciones. Evita que las DOS instancias del NotificationBell
// (sidebar de escritorio + barra móvil, ambas siempre montadas) hagan peticiones por separado.
let data = { notificaciones: [], no_leidas: 0 };
const subs = new Set();
let timer = null;
let inflight = null;

function emit() {
  subs.forEach((fn) => fn(data));
}

export function getNotifData() {
  return data;
}

// fresh=true: después de marcar como leída(s). Si ya había una consulta en curso, empezó ANTES del cambio y
// traería el estado viejo; se espera a que termine y se pide otra.
export function refreshNotifs(fresh = false) {
  if (inflight) return fresh ? inflight.then(() => refreshNotifs()) : inflight;
  inflight = api
    .get("/notificaciones")
    .then((r) => {
      data = r.data;
      emit();
    })
    .catch(() => {})
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function subscribeNotifs(fn) {
  subs.add(fn);
  fn(data);
  if (!timer) {
    refreshNotifs();
    timer = setInterval(refreshNotifs, 45000);
  }
  return () => {
    subs.delete(fn);
    if (subs.size === 0 && timer) {
      clearInterval(timer);
      timer = null;
    }
  };
}
